var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.senderId == _vm.userId)?_c('span',{staticClass:"date-time-user date-time"},[_vm._v(" "+_vm._s(_vm.getHumanDate())+" ")]):_c('span',{staticClass:"date-time"},[_vm._v(" "+_vm._s(_vm.getHumanDate())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }